import { ReactNode } from 'react';

type Props = {
  expanded: boolean;
  className?: string;
  children: ReactNode;
};

// Animates height via a grid-rows transition and makes collapsed content inert
// (unfocusable, hidden from AT) while keeping it mounted.
export const Collapsible = ({ expanded, className, children }: Props) => (
  <div
    className={`grid transition-[grid-template-rows] duration-[250ms] ease-out ${
      expanded ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
    }${className ? ` ${className}` : ''}`}
  >
    <div
      ref={(el) => {
        if (el) el.inert = !expanded;
      }}
      className="overflow-hidden"
    >
      {children}
    </div>
  </div>
);
